import type { IconName, IconVariant } from '@lemonade-hq/uniclient-theme';
import type { FormattedText, TextColorVariant, UniclientAction, UniclientWizardComponent } from '..';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export interface Discount {
  readonly label: string;
  readonly details?: string;
}

export interface MoreInfo {
  readonly text: string;
  readonly icon?: IconName;
  readonly action?: UniclientAction;
}

export interface Benefit {
  readonly text: string;
  readonly icon:
    | IconName
    | {
        readonly name: IconName;
        readonly variant?: IconVariant;
      };
}

interface AdditionalComponent<TComponentAttributes extends string = string> {
  readonly description?: string;
  readonly component: UniclientWizardComponent<TComponentAttributes>;
}

export interface PriceProps<TComponentAttributes extends string = string> extends UniclientBaseComponentProps {
  readonly title?: string;
  readonly previousPrice?: FormattedText;
  readonly price: string;
  readonly period: string;
  readonly additionalComponent?: AdditionalComponent<TComponentAttributes>;
  readonly moreInfo?: MoreInfo;
  // TODO: rename benefits?
  readonly benefits?: Benefit[] | string[];
  readonly initialVisibleBenefits?: number;
  readonly discount?: Discount;
  readonly withDiamond?: boolean;
  readonly disclaimer?: string;
  readonly listColorVariant?: TextColorVariant;
  readonly disableMaxVisibleBenefits?: boolean;
  readonly drawerSize?: 'large' | 'medium' | 'small';
}

export type UniclientPriceProps = PriceProps & UniclientWizardComponentBase<'price'>;

export function price(props: PriceProps): UniclientPriceProps {
  return { ...props, type: 'price' };
}
